import classNames from "classnames";
import type React from "react";
import { Outlet } from "react-router-dom";

import style from "./TeamsLayoutContainer.module.css";

export const TeamsLayoutContainer: React.FC<{
  children: React.ReactNode;
  sidebarOpen: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ children, sidebarOpen, setSidebarOpen }) => {
  return (
    <div className={classNames(style.container, sidebarOpen && style.open)}>
      <div className={classNames(style.sidebar, sidebarOpen && style.sidebarOpen)}>{children}</div>
      <div className={style.page} onClick={() => sidebarOpen && setSidebarOpen(false)}>
        <Outlet />
      </div>
    </div>
  );
};
